import { render, staticRenderFns } from "./chatPanel.vue?vue&type=template&id=612292fe&scoped=true"
import script from "./chatPanel.vue?vue&type=script&lang=js"
export * from "./chatPanel.vue?vue&type=script&lang=js"
import style0 from "./chatPanel.vue?vue&type=style&index=0&id=612292fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612292fe",
  null
  
)

export default component.exports